module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    class: _vm.color,
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('p', {
    staticClass: "offscreen",
    attrs: {
      "tabindex": "0"
    }
  }, [_vm._v("Contenido. Se sugiere navegar con las flechas del teclado.")]), _vm._v(" "), _c('ui-title-cen', {
    attrs: {
      "title": "Administración del Dinero"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Introducción',
      "videoEmbed": "ADMINISTRACIONDINERO01.mp4"
    },
    on: {
      "hideVideo": _vm.hideVideo
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm8": ""
    }
  }, [_c('br'), _vm._v(" "), _c('p', [_vm._v("\n       En este curso usted aprenderá a "), _c('strong', [_vm._v("administrar")]), _vm._v(" el dinero, tomar decisiones acertadas y  alcanzar las "), _c('strong', [_vm._v("metas")]), _vm._v(" propuestas. \n       De igual manera, entenderá qué es un "), _c('strong', [_vm._v("presupuesto")]), _vm._v(" y cómo elaborarlo paso a paso.\n      ")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.linksPath + '1',
      "aria-label": "Iniciar el curso"
    }
  }, [_c('ui-button-circle-secondary', {
    staticClass: "animated bounceIn dura_1",
    attrs: {
      "aria-hidden": "true",
      "aria": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39b8f07d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inicio.vue
// module id = 961
// module chunks = 1